import React from 'react';
import exact from 'prop-types-exact';

import { BaseField } from '../../../fields';

export const validate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Required';
  }

  return errors;
};


const PasswordResetRequestFormSection = (props) => {
  return (
    <div>
      <BaseField name="email" label="Please Enter in Your Email" />
    </div>
  );
};


PasswordResetRequestFormSection.propTypes = exact({});

export default PasswordResetRequestFormSection;
